import {hideLoading, showLoading} from 'app/general/sweet-loading-bar';

import {apiQuery} from '../api-query';

import type {
  MutationLifecycleApi,
  QueryLifecycleApi,
} from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export function showLoadingBar(
  args: unknown,
  api:
    | QueryLifecycleApi<unknown, typeof apiQuery, unknown, 'sweetAPI'>
    | MutationLifecycleApi<unknown, typeof apiQuery, unknown, 'sweetAPI'>
): Promise<void> | void {
  const {dispatch, queryFulfilled} = api;

  dispatch(showLoading());

  queryFulfilled.then(
    (r) => {
      dispatch(hideLoading());
      return r;
    },
    (err) => {
      dispatch(hideLoading());
      throw err;
    }
  );
}
